module.exports = __webpack_public_path__ + "1d9590c33ed0d559f888dffa673ab434.gltf";